export const DEFAULT_PRODUCT_FILTERS = ['TK30', 'HK30', 'PM30'];
export const DEFAULT_PRODUCT = 'TK30';
export const BV_PRODUCT_ID_MAPPING = {
  TK30: 'TruDefinition Duration',
  HK30: 'Oakridge Shingles',
  PM30: 'Supreme Shingles',
  All: 'All',
};
